const SvgIconDownArrow = (props) => (
  <svg width="19" height="11" viewBox="0 0 19 11" {...props}>
    <path d="M1.5 1L9.98528 9.48528L18.4706 1" fillRule="evenodd" fill="none" stroke="#000" strokeWidth="1.5" />

  </svg>
);

export default SvgIconDownArrow;
